import { AgentBlock, BlockChange } from '@basehub/data/replicache/index'
import { idToSourceBlockId } from '@basehub/data/replicache/mutators/repo-space/block/mutators/copy-on-write'
import { SYSTEM_AGENTS } from '@basehub/data/replicache/schema/block/agents'
import { useWorkingTreeStore } from '~/hooks-data/blocks-tree/provider'
import { useWorkingDiff } from '~/lib/diff/use-working-diff'

/**
 * This hook fetches the agents available in the BaseHub for a given branch in a repository.
 * It combines system agents with custom agents fetched from the API.
 * The agents are returned as a unique list based on their source block ID.
 */
export const useBaseHubAgents = () => {
  const { diff, treeOld } = useWorkingDiff()

  return useWorkingTreeStore((s) => {
    const agents: {
      block: AgentBlock
      diffStatus: BlockChange['status']
      isSystem: boolean
    }[] = []
    s.tree?.compoundIndexes
      .get('blocksByType')
      ?.get('agent')
      ?.forEach((aId) => {
        const agent = s.tree?.getNode(aId)?.value as
          | AgentBlock
          | null
          | undefined
        if (agent) {
          const diffStatus =
            diff?.changesTree.getNode(idToSourceBlockId(agent))?.value.status ??
            'unmodified'
          agents.push({
            block: agent,
            diffStatus,
            isSystem: SYSTEM_AGENTS.some(
              (a) => a.sourceBlockId === agent.sourceBlockId
            ),
          })
        }
      })
    if (treeOld) {
      treeOld?.compoundIndexes
        .get('blocksByType')
        ?.get('agent')
        ?.forEach((aId) => {
          const agent = treeOld?.getNode(aId)?.value as
            | AgentBlock
            | null
            | undefined
          if (agent) {
            const diffStatus =
              diff?.changesTree.getNode(idToSourceBlockId(agent))?.value
                .status ?? 'unmodified'
            if (diffStatus === 'deleted') {
              agents.push({
                block: agent,
                diffStatus,
                isSystem: SYSTEM_AGENTS.some(
                  (a) => a.sourceBlockId === agent.sourceBlockId
                ),
              })
            }
          }
        })
    }
    return agents
  })
}
